import React from 'react'
import {Modal} from 'react-bootstrap';

const JoinOurWaitlist = ({show,close}) => {
    return (
        <Modal show={show} onHide={close} centered className='custom-modal-style-1' size="lg">
            <Modal.Body className='bg-black text-center'>
                <h3>Join Waitlist</h3>
                <p className="fs-14">Stay ahead of the curve! Sign up with your email now for exclusive early access and stay in the loop with the latest updates!</p>

                <form action="">
                    <div className="mb-3">
                        <input type="text" className='form-control joinWishlistInput text-center' placeholder='Please enter your email' />
                    </div>
                    <button className='btn btn-primary rounded-pill btn-md px-5 mt-4 py-3'>Join Waitlist</button>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default JoinOurWaitlist